module.exports = __webpack_public_path__ + "static/media/romstandard2.271c9917.jpeg";